import React from 'react';
import {
  useRecordContext,
  TextField,
  useResourceDefinition,
  useCreatePath,
} from 'react-admin';
import LinkField from '../components/layout/LinkField';
import { getResourceFromName } from '../utilities/getResourceName';
import resourceNames from '../constants/resourceNames';

const ReferenceResourceField = ({ label }: {label: string}) => {
  const record = useRecordContext();
  const resource = getResourceFromName(record?.resource?.type);
  const resourceDef = useResourceDefinition({ resource });
  const createPath = useCreatePath();

  const link = (() => {
    if (resource === resourceNames.RULES) {
      return `/rules/${record?.resource?.id}/summary`;
    }
    if (resource === resourceNames.MEMBERS) {
      return createPath({ type: 'edit', resource, id: record?.resource?.id });
    }
    if (resource === resourceNames.PERMISSION_ROLES) {
      return createPath({ type: 'edit', resource, id: record?.resource?.id });
    }
    if (resource === resourceNames.API_KEYS) {
      return createPath({ type: 'edit', resource, id: record?.resource?.id });
    }

    if (resourceDef.hasEdit) {
      return createPath({ type: 'edit', resource, id: record?.resource?.id });
    }

    if (resourceDef.hasShow) {
      return createPath({ type: 'show', resource, id: record?.resource?.id });
    }

    return false;
  })();

  return link ? (
    <LinkField label={label} sortable={false} source="resource.id" link={link} />
  ) : (
    <TextField label={label} sortable={false} source="resource.id" />
  );
};

export default ReferenceResourceField;
